import { Link } from "react-router-dom";

export function ForgotPasswordPage() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4 py-12">
      <div className="max-w-md w-full bg-white rounded-lg shadow-md p-8 text-center">
        <div className="mb-4 text-yellow-600 text-5xl">⚠️</div>
        <h1 className="text-2xl font-bold text-gray-900 mb-4">
          Password Reset Unavailable
        </h1>
        <p className="text-gray-600 mb-4">
          Password reset via email is not currently configured. Please contact
          an administrator if you've forgotten your password.
        </p>
        <p className="text-sm text-gray-500 mb-6">
          To enable password reset, configure email verification in the Convex
          Auth settings.
        </p>
        <Link
          to="/signin"
          className="inline-block px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
        >
          Back to Sign In
        </Link>
      </div>
    </div>
  );
}
